import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/not-found.svg'


const _hoisted_1 = { class: "empty-state" }
const _hoisted_2 = { class: "empty-state__content" }
const _hoisted_3 = { class: "empty-state__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "empty-state__icon" }, [
        _createElementVNode("img", {
          class: "empty-state__icon-image",
          src: _imports_0,
          alt: "No data"
        })
      ], -1)),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1)
    ])
  ]))
}